import { IMyMealPayload } from "model/food/types/mealPayload.types"
import { IMyFood } from "model/food/types/myfood.types"
import { LogMealType } from "model/food/types/base.types"
import { getImagePayload } from "./getImagePayload"
import getBaseMealPayloadFromFood from "./getBaseMealPayloadFromFood"

export const getMyMealPayloadFromFood = (
  food: IMyFood,
  mealType?: LogMealType,
) => {
  const payload: IMyMealPayload = {
    ...getBaseMealPayloadFromFood(food),
    ...getImagePayload(food),
    source: "MY_FOOD",
    type: mealType,
    ingredients: food.ingredients,
  }

  return payload
}
